import { render, staticRenderFns } from "./TestVideoEdit.vue?vue&type=template&id=8b0c373c&"
import script from "./TestVideoEdit.vue?vue&type=script&lang=js&"
export * from "./TestVideoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports